import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

type ColumnVisibilityAnalyticIds = {
  menuButtonAnalyticId: string;
  selectAllCheckboxAnalyticId: string;
};

export const useColumnVisibilityAnalyticIds = (): ColumnVisibilityAnalyticIds => ({
  menuButtonAnalyticId: useAnalyticId(AnalyticIdentifier.COLUMN_VISIBILITY_MENU_BUTTON),
  selectAllCheckboxAnalyticId: useAnalyticId(AnalyticIdentifier.COLUMN_VISIBILITY_MENU_SELECT_ALL_CHECKBOX),
});
